import React, { AnchorHTMLAttributes } from 'react';

const ExternalLink = ({ children, href, ...others }: AnchorHTMLAttributes<HTMLAnchorElement>) => {
  return (
    <a {...others} href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
};

export default ExternalLink;
